import React from 'react';
import PropTypes from 'prop-types';
import { ErrorBoundary } from 'react-error-boundary';
// eslint-disable-next-line import/no-cycle
import AppErrorRenderer from './AppErrorRenderer';

const AppErrorBoundary = ({ children }) => (
    <ErrorBoundary FallbackComponent={AppErrorRenderer}>
      {children}
    </ErrorBoundary>
  );

AppErrorBoundary.propTypes = {
  children: PropTypes.node
};

export default AppErrorBoundary;
